(function () {
  const ACCORDION_DURATION = 400;
  const ACCORDION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function initCollapsibleAccordions() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.collapsible-content .accordion details').forEach((details) => {
      const summary = details.querySelector('summary');
      const panel = summary?.nextElementSibling;
      const accordion = details.closest('.accordion');

      if (!summary || !panel?.classList.contains('accordion__panel')) return;
      if (summary.dataset.accordionBound === 'true') return;

      summary.dataset.accordionBound = 'true';
      panel.style.transition = `height ${ACCORDION_DURATION}ms ${ACCORDION_EASING}`;
      panel.style.overflow = 'hidden';

      if (details.hasAttribute('open')) {
        panel.style.height = 'auto';
      } else {
        panel.style.height = '0px';
      }

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (panel.dataset.animating === 'true') return;

        const willOpen = !details.hasAttribute('open');
        panel.dataset.animating = 'true';
        accordion?.classList.add('is-accordion-animating');

        const complete = (open) => {
          panel.dataset.animating = 'false';
          accordion?.classList.remove('is-accordion-animating');
          summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        if (willOpen) {
          details.setAttribute('open', '');

          const targetHeight = panel.scrollHeight;
          panel.style.height = '0px';
          panel.offsetHeight;

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              panel.style.height = `${targetHeight}px`;
            });
          });

          let finished = false;
          const onDone = () => {
            if (finished) return;
            finished = true;
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', onTransitionEnd);
            clearTimeout(fallback);
            complete(true);
          };

          const onTransitionEnd = (e) => {
            if (e.target !== panel || e.propertyName !== 'height') return;
            onDone();
          };

          panel.addEventListener('transitionend', onTransitionEnd);
          const fallback = setTimeout(onDone, ACCORDION_DURATION + 100);
        } else {
          const startHeight = panel.offsetHeight;
          panel.style.height = `${startHeight}px`;
          panel.offsetHeight;

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              panel.style.height = '0px';
            });
          });

          let finished = false;
          const onDone = () => {
            if (finished) return;
            finished = true;
            details.removeAttribute('open');
            panel.style.height = '0px';
            panel.removeEventListener('transitionend', onTransitionEnd);
            clearTimeout(fallback);
            complete(false);
          };

          const onTransitionEnd = (e) => {
            if (e.target !== panel || e.propertyName !== 'height') return;
            onDone();
          };

          panel.addEventListener('transitionend', onTransitionEnd);
          const fallback = setTimeout(onDone, ACCORDION_DURATION + 100);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapsibleAccordions);
  } else {
    initCollapsibleAccordions();
  }

  document.addEventListener('shopify:section:load', initCollapsibleAccordions);
})();
